export const works = [
  {
    id: 'chenxi-zhiyue',
    title: '晨曦之约',
    type: '电影',
    year: 2024,
    genre: '剧情 / 爱情',
    director: '高桥慎一',
    starring: ['夏目彩春', '松本和也', '伊藤诗织'],
    duration: '128分钟',
    rating: 8.7,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20young%20asian%20woman%20standing%20by%20a%20dawn%20window%2C%20soft%20golden%20morning%20light%20streaming%20in%2C%20moody%20dramatic%20cinematic%20lighting%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20minimal%20textured%20background%2C%20editorial%20poster%20photography%2C%20fine%20film%20grain%2C%20elegant%20composition&width=600&height=840&seq=natsume-work-01&orientation=portrait',
    summary: '一个关于等待与重逢的温柔故事，夏目彩春以细腻表演诠释时间缝隙里的爱。',
    synopsis: [
      '在一座被晨雾笼罩的海边小城，女主角凛经营着一家即将关门的老书店。她每天清晨都会在窗边留一盏灯，等待一个十年前约定重逢的人。',
      '一场突如其来的台风打乱了小城的节奏，也让一封尘封多年的信件重新回到她的手中。过往的记忆与现实的抉择交织，凛必须重新定义「约定」的意义。',
      '影片以自然光与长镜头见长，夏目彩春用克制的表演呈现了一个女性在时间中的成长，被誉为她近年最具代表性的作品。',
    ],
    role: '饰演 凛',
    roleDesc: '书店女主人凛，表面平静克制，内心藏着十年的等待。夏目彩春通过微表情与呼吸节奏的细微变化，将角色的隐忍与温柔层层递进地呈现出来。',
  },
  {
    id: 'dongjing-mitu',
    title: '东京迷途',
    type: '电视剧',
    year: 2025,
    genre: '悬疑 / 犯罪',
    director: '小林志郎',
    starring: ['夏目彩春', '中村悠一', '石原里美'],
    duration: '全12集',
    rating: 9.1,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20thriller%20poster%20of%20an%20asian%20woman%20in%20a%20trench%20coat%20walking%20through%20a%20rainy%20neon%20tokyo%20alley%20at%20night%2C%20wet%20reflective%20asphalt%2C%20deep%20blue%20and%20cold%20cyan%20tones%20with%20a%20single%20warm%20light%2C%20moody%20atmospheric%20lighting%2C%20editorial%20poster%20photography%2C%20film%20grain&width=600&height=840&seq=natsume-work-02&orientation=portrait',
    summary: '雨夜、霓虹与一桩悬案，刑警桐生凛在迷雾重重的都市里追查真相。',
    synopsis: [
      '东京连续发生多起看似无关的失踪案，刑警桐生凛在追查过程中发现所有线索都指向同一个被遗忘的街区。',
      '随着调查深入，案件与她自己的过去产生了意想不到的关联。信任与背叛、正义与私情之间的界限变得越来越模糊。',
      '该剧以冷峻的影像风格和紧凑的叙事节奏获得高度评价，夏目彩春首次挑战刑警角色，动作戏与心理戏均有突破。',
    ],
    role: '饰演 桐生凛',
    roleDesc: '警视厅搜查一课刑警桐生凛，冷静、敏锐却背负着沉重的过往。夏目彩春为此剧进行了大量体能与格斗训练，塑造出一个硬朗又不失人性的女性形象。',
  },
  {
    id: 'haibian-de-xin',
    title: '海边的信',
    type: '电影',
    year: 2023,
    genre: '爱情 / 文艺',
    director: '佐藤和彦',
    starring: ['夏目彩春', '冈田将生'],
    duration: '116分钟',
    rating: 8.4,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20romantic%20film%20poster%20of%20an%20asian%20woman%20standing%20on%20a%20sunny%20seaside%20pier%20holding%20an%20old%20letter%2C%20soft%20pastel%20sky%2C%20gentle%20sea%20breeze%2C%20warm%20sunlight%20and%20muted%20blue%20tones%2C%20minimal%20calm%20composition%2C%20editorial%20poster%20photography%2C%20delicate%20film%20grain&width=600&height=840&seq=natsume-work-03&orientation=portrait',
    summary: '一封跨越时空的信，连接起两段错过彼此的人生。',
    synopsis: [
      '女主角纱织在整理祖母遗物时，发现了一叠从未寄出的信件。信中的故事指向一个她从未听说过的小镇与一段被隐藏的恋情。',
      '带着疑问，纱织踏上了追寻真相的旅程，在海边的小镇上遇见了同样在寻找答案的邮递员。',
      '影片以缓慢而温柔的叙事，探讨记忆、遗憾与和解，被誉为治愈系爱情片的代表作。',
    ],
    role: '饰演 纱织',
    roleDesc: '追寻祖母往事的年轻女性纱织，敏感而坚定。夏目彩春以大量无台词的情绪戏份，呈现出一个安静却充满力量的角色。',
  },
  {
    id: 'niguang-erxing',
    title: '逆光而行',
    type: '电视剧',
    year: 2024,
    genre: '励志 / 职场',
    director: '田中惠美',
    starring: ['夏目彩春', '妻夫木聪', '井上真央'],
    duration: '全10集',
    rating: 8.8,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20a%20confident%20asian%20businesswoman%20standing%20in%20a%20modern%20glass%20office%20at%20golden%20hour%2C%20strong%20backlight%20rim%20light%20on%20her%20silhouette%2C%20warm%20amber%20highlights%20against%20deep%20navy%20shadows%2C%20editorial%20poster%20photography%2C%20film%20grain&width=600&height=840&seq=natsume-work-04&orientation=portrait',
    summary: '在男性主导的行业中，一位女性用实力撕开偏见，走出一条属于自己的路。',
    synopsis: [
      '建筑设计师相马茜在晋升关键节点被调往濒临倒闭的分公司，面对资源匮乏与团队离散的双重困境。',
      '她带领一群「边缘人」接下了一个看似不可能完成的地标项目，在一次次挫败中重建团队的信任。',
      '剧集聚焦职场现实与女性成长，夏目彩春塑造的领导者形象既有锋芒也有柔软，引发广泛共鸣。',
    ],
    role: '饰演 相马茜',
    roleDesc: '建筑师相马茜，专业、果决、不肯妥协。夏目彩春为角色研究了大量建筑行业案例，让一个理想主义者显得真实可信。',
  },
  {
    id: 'xueguo-zhilie-zhiye',
    title: '雪国列车之夜',
    type: '电影',
    year: 2022,
    genre: '剧情 / 公路',
    director: '高桥慎一',
    starring: ['夏目彩春', '渡边谦'],
    duration: '134分钟',
    rating: 8.6,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20winter%20film%20poster%20of%20an%20asian%20woman%20gazing%20out%20the%20window%20of%20a%20moving%20snow%20train%2C%20frosted%20glass%2C%20deep%20snowy%20landscape%20passing%20by%2C%20cool%20blue%20and%20silver%20tones%20with%20a%20warm%20cabin%20light%2C%20moody%20atmospheric%20lighting%2C%20editorial%20poster%20photography%2C%20film%20grain&width=600&height=840&seq=natsume-work-05&orientation=portrait',
    summary: '一趟穿越雪国的列车，载着陌生人之间短暂而深刻的相遇。',
    synopsis: [
      '在一场暴雪中，开往北方的列车被迫停靠。车厢里的乘客来自不同阶层，各自带着不愿言说的故事。',
      '女主角千夏与一位年迈的乘客在长夜里展开对话，两个陌生人逐渐交换了彼此最深的遗憾。',
      '影片以一镜到底的车厢长镜头著称，夏目彩春的表演克制而厚重，被评价为「安静得令人心碎」。',
    ],
    role: '饰演 千夏',
    roleDesc: '独自旅行的女性千夏，在雪夜中与陌生人敞开心扉。夏目彩春几乎全程以车内空间完成表演，展现极强的角色掌控力。',
  },
  {
    id: 'dushi-fusheng',
    title: '都市浮生',
    type: '电视剧',
    year: 2023,
    genre: '都市 / 家庭',
    director: '小林志郎',
    starring: ['夏目彩春', '松隆子', '阿部宽'],
    duration: '全16集',
    rating: 8.5,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20of%20an%20asian%20woman%20standing%20on%20an%20apartment%20balcony%20overlooking%20a%20dusk%20city%20skyline%2C%20warm%20orange%20sunset%20glow%20against%20cool%20grey%20buildings%2C%20moody%20cinematic%20lighting%2C%20editorial%20poster%20photography%2C%20film%20grain&width=600&height=840&seq=natsume-work-06&orientation=portrait',
    summary: '三组家庭、一栋老楼，写尽都市里平凡人的悲欢。',
    synopsis: [
      '故事发生在一栋即将拆迁的老公寓里，三户人家因一条狗、一场漏水与一间学区房纠缠在一起。',
      '女主角美咲是其中一家的母亲，在事业与家庭之间疲于奔命，试图守住属于自己的小小天地。',
      '剧集以群像叙事呈现都市生活的温度与无奈，夏目彩春的表演自然细腻，被观众称为「像身边的人」。',
    ],
    role: '饰演 美咲',
    roleDesc: '在职场与家庭间奔波的中年母亲美咲，真实、疲惫却始终温柔。夏目彩春褪去光环，塑造出一个极具烟火气的平凡女性。',
  },
  {
    id: 'wusheng-gaobai',
    title: '无声告白',
    type: '电影',
    year: 2025,
    genre: '悬疑 / 剧情',
    director: '佐藤和彦',
    starring: ['夏目彩春', '二宫和也'],
    duration: '122分钟',
    rating: 9.0,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20suspense%20film%20poster%20of%20an%20asian%20woman%20in%20a%20dim%20room%20lit%20by%20a%20single%20cold%20window%20light%2C%20her%20face%20half%20in%20shadow%2C%20deep%20teal%20and%20charcoal%20tones%20with%20a%20hint%20of%20amber%2C%20tense%20atmospheric%20lighting%2C%20editorial%20poster%20photography%2C%20film%20grain&width=600&height=840&seq=natsume-work-07&orientation=portrait',
    summary: '一场没有凶器、没有证人、也没有声音的案件，真相藏在沉默之中。',
    synopsis: [
      '一名聋哑女子被卷入一场离奇的命案，唯一能证明她清白的，是一段没有人听懂的监控影像。',
      '辩护律师与她之间隔着无声的墙，两人必须用最笨拙的方式拼凑出被忽视的真相。',
      '影片以声音设计为核心，夏目彩春首次挑战无台词表演，用肢体与眼神撑起整部电影。',
    ],
    role: '饰演 静',
    roleDesc: '聋哑女子静，全片几乎没有台词。夏目彩春为此学习手语数月，以极具张力的肢体语言完成一次高难度表演。',
  },
  {
    id: 'yingse-liunian',
    title: '樱色流年',
    type: '电视剧',
    year: 2022,
    genre: '青春 / 校园',
    director: '田中惠美',
    starring: ['夏目彩春', '广濑铃', '山崎贤人'],
    duration: '全12集',
    rating: 8.2,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20youth%20drama%20poster%20of%20an%20asian%20young%20woman%20standing%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20falling%2C%20bright%20airy%20daylight%2C%20delicate%20pastel%20pink%20and%20cream%20tones%2C%20nostalgic%20gentle%20atmosphere%2C%20editorial%20poster%20photography%2C%20film%20grain&width=600&height=840&seq=natsume-work-08&orientation=portrait',
    summary: '樱花树下的三年时光，记录一群少年最纯粹的喜欢与告别。',
    synopsis: [
      '故事围绕高中摄影社的四名成员展开，他们约定在毕业前一起完成一本关于樱花的影集。',
      '女主角遥在梦想与现实之间摇摆，而那个总在取景框外的少年，成了她镜头里始终缺失的一格。',
      '剧集以明亮清新的影像呈现青春群像，是夏目彩春早期的代表作品之一。',
    ],
    role: '饰演 遥',
    roleDesc: '热爱摄影的高中女生遥，天真又倔强。夏目彩春以自然的少女感演出了青春特有的明亮与迷茫。',
  },
  {
    id: 'zuihou-de-huashi',
    title: '最后的画师',
    type: '电影',
    year: 2024,
    genre: '传记 / 剧情',
    director: '高桥慎一',
    starring: ['夏目彩春', '役所广司'],
    duration: '141分钟',
    rating: 9.2,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20biographical%20film%20poster%20of%20an%20asian%20woman%20in%20a%20traditional%20art%20studio%20holding%20a%20painting%20brush%2C%20warm%20lantern%20light%2C%20rich%20earth%20and%20deep%20indigo%20tones%2C%20paint%20splattered%20wooden%20desk%2C%20moody%20cinematic%20lighting%2C%20editorial%20poster%20photography%2C%20film%20grain&width=600&height=840&seq=natsume-work-09&orientation=portrait',
    summary: '在传统绘画的余晖中，一位女性守护着即将失传的技艺。',
    synopsis: [
      '影片讲述日本画师绫子的艺术人生，她以一己之力对抗日益式微的传统装裱工艺。',
      '在师门离散、市场萎缩的困境中，绫子选择了一条最难却最忠于内心的路。',
      '电影横跨三十年时光，夏目彩春从青年演到暮年，凭借该片获得年度最佳女主角提名。',
    ],
    role: '饰演 绫子（中青年）',
    roleDesc: '传统绘画守护者绫子，从二十岁演到六十岁。夏目彩春通过体态、声线与眼神的变化，完成了一次跨度极大的表演。',
  },
  {
    id: 'fengqi-changjie',
    title: '风起长街',
    type: '电视剧',
    year: 2025,
    genre: '古装 / 权谋',
    director: '小林志郎',
    starring: ['夏目彩春', '陈坤', '周迅'],
    duration: '全24集',
    rating: 9.3,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20historical%20epic%20poster%20of%20an%20elegant%20asian%20woman%20in%20flowing%20traditional%20robes%20standing%20in%20an%20ancient%20lantern-lit%20street%2C%20wind%20lifting%20her%20sleeves%2C%20deep%20crimson%20and%20ink%20black%20tones%20with%20golden%20highlights%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20poster%20photography%2C%20film%20grain&width=600&height=840&seq=natsume-work-10&orientation=portrait',
    summary: '长街之上风起云涌，一位女子以智慧搅动整座王朝的棋局。',
    synopsis: [
      '故事设定在虚构的东陆王朝，出身商贾的女主角沈清歌凭一手过人的算计进入权力中心。',
      '在朝堂与江湖的双线博弈中，她要面对的不只是敌人，还有自己日渐模糊的初心。',
      '剧集以考究的美术与紧凑的权谋叙事成为年度现象级作品，夏目彩春的古装造型与表演均引发热议。',
    ],
    role: '饰演 沈清歌',
    roleDesc: '聪慧果敢的商贾之女沈清歌，在权谋棋局中步步为营。夏目彩春以沉稳的气场与凌厉的眼神，塑造出一个野心与柔情并存的女主。',
  },
];

export const workGenres = ['剧情', '爱情', '悬疑', '犯罪', '励志', '职场', '都市', '家庭', '青春', '校园', '传记', '古装', '权谋', '公路', '文艺'];

export const workYears = [2025, 2024, 2023, 2022];